{
  "loading": "Laadimine...",
  "placeholder": "Valige…"
}
